import React from 'react';
import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../Interfaces.style';
import DicomSendingNodes from './DicomSendingNodes';
import DicomQueryingNodes from './DicomQueryingNodes';

const DicomInterfaces = ({ setReportRulesChanged }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      <Typography
        variant='h6'
        color='primary'
        className={`${classes.titleSettingsCard} ${classes.title_margin}`}
      >
        {t('Settings.dicom_interfaces')}
      </Typography>

      <DicomSendingNodes setReportRulesChanged={setReportRulesChanged} />
      <DicomQueryingNodes setReportRulesChanged={setReportRulesChanged} />
    </>
  );
};

export default DicomInterfaces;
